import { Chip, HorizontalRail } from "../../design-v2";

function isSameSelection(left, right) {
  return String(left) === String(right);
}

/**
 * Canonical shared filter rail (Phase 9).
 *
 * Presentation only. It owns no search state, no filter state, no fetching and
 * no business filtering semantics: the consuming library page keeps all of
 * that and passes the resolved option list, the current value and a callback.
 *
 * The rail MAY scroll horizontally; the consuming page MUST NOT.
 */
export default function FilterRail({
  options = [],
  value,
  onChange,
  label = "Filters",
  className = "",
}) {
  return (
    <HorizontalRail
      className={["lz-product-filter-rail", className].filter(Boolean).join(" ")}
      aria-label={label}
      activeItem={value}
      snap="start"
    >
      {options.map((option) => {
        const isActive = isSameSelection(option.value, value);

        return (
          <Chip
            key={option.value}
            className="lz-product-filter-rail__chip"
            data-rail-item={option.value}
            selected={isActive}
            aria-current={isActive ? "true" : undefined}
            onClick={() => onChange?.(option.value)}
          >
            {option.label}
          </Chip>
        );
      })}
    </HorizontalRail>
  );
}
